// extracted by mini-css-extract-plugin
export var wordContainer = "_my-0";